import {
  Anchor,
  Award,
  Boxes,
  BriefcaseBusiness,
  Building,
  Building2,
  Calculator,
  Camera,
  ClipboardList,
  Coffee,
  Cog,
  Construction,
  Container,
  CreditCard,
  Crown,
  Database,
  DollarSign,
  Factory,
  FileText,
  Flag,
  Forklift,
  Globe,
  GraduationCap,
  Hammer,
  Handshake,
  HardHat,
  Headset,
  Home,
  Landmark,
  Laptop,
  Leaf,
  Lightbulb,
  MapPin,
  Megaphone,
  Music,
  Package,
  Palette,
  PenTool,
  PersonStanding,
  Phone,
  Plane,
  Puzzle,
  Recycle,
  Rocket,
  Scale,
  Server,
  Ship,
  Shield,
  Star,
  Stethoscope,
  Store,
  Target,
  Tractor,
  TrendingUp,
  Truck,
  UserCheck,
  UserCog,
  UserMinus,
  UserPlus,
  UserRound,
  UserX,
  Users,
  Utensils,
  Warehouse,
  Wifi,
  Wrench,
  type LucideIcon,
} from 'lucide-react';

import type { OrgMvpFigureKey } from './organogramaTypes';

export type OrgMvpFigureCatalogItem = {
  key: OrgMvpFigureKey;
  label: string;
  icon: LucideIcon;
};

export const figureCatalog: OrgMvpFigureCatalogItem[] = [
  { key: 'person', label: 'Pessoa', icon: UserRound },
  { key: 'woman', label: 'Mulher/Homem', icon: PersonStanding },
  { key: 'team', label: 'Equipe', icon: Users },
  { key: 'manager', label: 'Gestor', icon: UserCog },
  { key: 'operator', label: 'Operador', icon: UserCheck },
  { key: 'executive', label: 'Diretoria/Executivo', icon: Crown },
  { key: 'user_add', label: 'Contratação', icon: UserPlus },
  { key: 'user_remove', label: 'Desligamento', icon: UserMinus },
  { key: 'user_block', label: 'Inativo', icon: UserX },
  { key: 'hr', label: 'RH/Treinamento', icon: GraduationCap },
  { key: 'health', label: 'Saúde/Medicina', icon: Stethoscope },
  { key: 'security', label: 'Segurança', icon: Shield },
  { key: 'maintenance', label: 'Manutenção', icon: Wrench },
  { key: 'construction_worker', label: 'Obra/Campo', icon: HardHat },
  { key: 'admin', label: 'Administrativo', icon: ClipboardList },
  { key: 'finance', label: 'Financeiro', icon: Calculator },
  { key: 'bank', label: 'Banco/Investimento', icon: Landmark },
  { key: 'sales', label: 'Vendas/Comercial', icon: Store },
  { key: 'marketing', label: 'Marketing', icon: Megaphone },
  { key: 'support', label: 'Suporte/Atendimento', icon: Headset },
  { key: 'legal', label: 'Jurídico', icon: Scale },
  { key: 'logistics_ship', label: 'Logística (navio)', icon: Ship },
  { key: 'logistics_plane', label: 'Logística (aérea)', icon: Plane },
  { key: 'agro', label: 'Agronegócio', icon: Tractor },
  { key: 'sustainability', label: 'Sustentabilidade', icon: Leaf },
  { key: 'recycle', label: 'Reciclagem', icon: Recycle },
  { key: 'it', label: 'TI/Infraestrutura', icon: Server },
  { key: 'data', label: 'Dados/Banco de dados', icon: Database },
  { key: 'dev', label: 'Desenvolvimento', icon: Laptop },
  { key: 'network', label: 'Redes', icon: Wifi },
  { key: 'design', label: 'Design/Criação', icon: Palette },
  { key: 'design_tool', label: 'Design gráfico', icon: PenTool },
  { key: 'media', label: 'Mídia/Fotografia', icon: Camera },
  { key: 'music', label: 'Áudio/Música', icon: Music },
  { key: 'food', label: 'Alimentação', icon: Utensils },
  { key: 'coffee', label: 'Copa/Cafeteria', icon: Coffee },
  { key: 'innovation', label: 'Inovação', icon: Lightbulb },
  { key: 'growth', label: 'Crescimento', icon: TrendingUp },
  { key: 'startup', label: 'Projetos/Startup', icon: Rocket },
  { key: 'goal', label: 'Metas/Objetivos', icon: Target },
  { key: 'partnership', label: 'Parcerias', icon: Handshake },
  { key: 'award', label: 'Reconhecimento', icon: Award },
  { key: 'star', label: 'Destaque', icon: Star },
  { key: 'flag', label: 'Marco/Bandeira', icon: Flag },
  { key: 'location', label: 'Unidade/Filial', icon: MapPin },
  { key: 'global', label: 'Internacional', icon: Globe },
  { key: 'phone', label: 'Telefonia', icon: Phone },
  { key: 'document', label: 'Documentos', icon: FileText },
  { key: 'currency', label: 'Pagamentos', icon: DollarSign },
  { key: 'card', label: 'Cartão/Cobrança', icon: CreditCard },
  { key: 'puzzle', label: 'Integração', icon: Puzzle },
  { key: 'settings', label: 'Processos', icon: Cog },
  { key: 'tools', label: 'Ferramentas', icon: Hammer },
  { key: 'anchor', label: 'Porto/Naval', icon: Anchor },
  { key: 'home', label: 'Sede/Matriz', icon: Home },
  { key: 'forklift', label: 'Empilhadeira', icon: Forklift },
  { key: 'warehouse', label: 'Armazém', icon: Warehouse },
  { key: 'truck', label: 'Caminhão', icon: Truck },
  { key: 'factory', label: 'Fábrica', icon: Factory },
  { key: 'construction', label: 'Obra', icon: Construction },
  { key: 'package', label: 'Pacote', icon: Package },
  { key: 'boxes', label: 'Caixas', icon: Boxes },
  { key: 'container', label: 'Container', icon: Container },
  { key: 'briefcase', label: 'Administrativo (mala)', icon: BriefcaseBusiness },
  { key: 'building', label: 'Prédio', icon: Building2 },
  { key: 'building_alt', label: 'Prédio (alt.)', icon: Building },
];

export const figureCatalogByKey = new Map(figureCatalog.map((item) => [item.key, item]));
